import React from "react";
import { useRef } from "react";
import emailjs from "@emailjs/browser";
import { Snackbar } from "@mui/material";
import {
  Container,
  Wrapper,
  Title,
  Desc,
  ContactButton,
  ContactForm,
  ContactInput,
  ContactInputMessage,
  ContactTitle,
} from "./ContactStyledComponent";

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const Contact = () => {
  const [open, setOpen] = React.useState(false);
  const [values, setValues] = React.useState({
    from_email: "",
    from_name: "",
    subject: "",
    message: "",
  });
  const form = useRef();

  const isValid =
    EMAIL_PATTERN.test(values.from_email.trim()) &&
    values.from_name.trim().length > 0 &&
    values.subject.trim().length > 0 &&
    values.message.trim().length > 0;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setValues((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!isValid) return;
    emailjs
      .sendForm(
        "service_oyxnivl",
        "template_nv7k7mj",
        form.current,
        "SybVGsYS52j2TfLbi"
      )
      .then(
        (result) => {
          setOpen(true);
          form.current.reset();
          setValues({ from_email: "", from_name: "", subject: "", message: "" });
        },
        (error) => {
          console.log(error.text);
        }
      );
  };

  return (
    <Container id="contact">
      <Wrapper>
        <Title>Contact</Title>
        <Desc>
          Feel free to reach out to me for any questions or opportunities!
        </Desc>
        <ContactForm ref={form} onSubmit={handleSubmit}>
          <ContactTitle>Email Me 🚀</ContactTitle>
          <ContactInput
            placeholder="Your Email"
            name="from_email"
            type="email"
            value={values.from_email}
            onChange={handleChange}
            required
          />
          <ContactInput
            placeholder="Your Name"
            name="from_name"
            value={values.from_name}
            onChange={handleChange}
            required
          />
          <ContactInput
            placeholder="Subject"
            name="subject"
            value={values.subject}
            onChange={handleChange}
            required
          />
          <ContactInputMessage
            placeholder="Message"
            rows="4"
            name="message"
            value={values.message}
            onChange={handleChange}
            required
          />
          <ContactButton type="submit" value="Send" disabled={!isValid} />
        </ContactForm>
        <Snackbar
          open={open}
          autoHideDuration={6000}
          onClose={() => setOpen(false)}
          message="Email sent successfully!"
          severity="success"
        />
      </Wrapper>
    </Container>
  );
};

export default Contact;
